module.exports = __webpack_public_path__ + "img/aviation_mix6.3d9cf8e4.jpg";